(function () {
    'use strict';

    angular
        .module('gov.services')
        .factory('errorManagementService', service);

    service.$inject = ['$state', 'authenticatedUserService', 'notificationService'];

    function service($state, authenticatedUserService, notificationService) {
        return {
            manageError: function(response) {

                if (response.status === 403) {
                    // Permission
                    notificationService.warn('You do not have the necessary permissions to access this page');
                    authenticatedUserService
                        .getAuthenticatedUser()
                        .then(function (user) {
                            $state.go(
                                'home',
                                {UserItemPersonID: user.MetaDataUser.ItemPersonID},
                                {replace: true}
                            );
                        });
                } else {
                    // all others
                    notificationService.warn('An unknown error occurred: ' + response.statusText);
                }
            }
        }
    }
})();